/**
 * @see https://github.com/IdentityModel/oidc-client-js/wiki
 */

import { Log, SigninRedirectArgs, User, UserManager, UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';

const APP_CONFIG = window.APP_CONFIG;
Log.setLogger(console);
Log.setLevel(Log.INFO);

class EnhancedUserManager extends UserManager {

    constructor(settings: UserManagerSettings) {
        super(settings);
    }

    /**
     * Get the user who is logged in.
     * If the user was deleted (expired) it restarts authentication.
     */
    getValidUser(): Promise<User> {
        return new Promise((resolve, reject) => {
            this.getUser()
                .then((user) => {
                    if (user == null) {
                        console.info('[oidc] renewing...');
                        this.signinRedirect()
                            .then(() => console.log('[oidc] renewed'));
                        //return resolve(null)
                    } else {
                        return resolve(user);
                    }
                })
                .catch((err) => {
                    console.error(err);
                    return reject(err);
                });
        });
    }

    async startLogin(path: string, locale?: string) {
        //console.debug("[oidc ] start login...")
        return userManager.signinRedirect({
            state: path,
            ui_locales: locale
        } as SigninRedirectArgs);
    }
}

export const userManager = new EnhancedUserManager({
    userStore: new WebStorageStateStore(),
    authority: APP_CONFIG.oauth.discoveryEndpoint,
    client_id: APP_CONFIG.oauth.clientId,
    redirect_uri: APP_CONFIG.oauth.redirectUri,
    response_type: APP_CONFIG.oauth.responseType,
    scope: APP_CONFIG.oauth.scopes,
    post_logout_redirect_uri: APP_CONFIG.oauth.post_logout_redirect_uri,
    //silent_redirect_uri: window.location.origin + '/static/silent-renew.html',
    accessTokenExpiringNotificationTimeInSeconds: 10,
    automaticSilentRenew: false,
    filterProtocolClaims: false,
    loadUserInfo: true,
    response_mode: 'query',
});

userManager.events.addAccessTokenExpiring(function () {
    console.warn('[oidc] AccessToken Expiring!');
});

userManager.events.addAccessTokenExpired(function () {
    console.info('[oidc] AccessToken Expired');
    userManager.removeUser()
        .then(() => {
            console.debug('[oidc] removed expired user from store');
        });
});

userManager.events.addSilentRenewError(function () {
    console.error('[oidc] Silent Renew Error');
});
